import { FirestoreDataConverter, DocumentData, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export const ROOM_PATH = "influencer_tickets";

export type RoomType = {
  id: string;
  influencerTicketId: string;
  influencerId: string;
  storeId: string;
  ticketId: string;
  latestMessage: string;
  influencerViewedTime: number | null;
  storeViewedTime: number | null;
  influencerSentTime: number | null;
  storeSentTime: number | null;
  adminSentTime: number | null;
  createTime: number;
  updateTime: number;
};

export const roomConverter: FirestoreDataConverter<RoomType> = {
  toFirestore(room: RoomType): DocumentData {
    return {
      id: room.id,
      influencerTicketId: room.influencerTicketId,
      influencerId: room.influencerId,
      storeId: room.storeId,
      ticketId: room.ticketId,
      latestMessage: room.latestMessage,
      influencerViewedTime: Math.round(room.influencerViewedTime || 0),
      storeViewedTime: Math.round(room.storeViewedTime || 0),
      influencerSentTime: Math.round(room.influencerSentTime || 0),
      storeSentTime: Math.round(room.storeSentTime || 0),
      adminSentTime: Math.round(room.adminSentTime || 0),
      createTime: Math.round(room.createTime || 0),
      updateTime: Math.round(room.updateTime || 0),
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): RoomType {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      influencerTicketId: data.influencerTicketId,
      influencerId: data.influencerId,
      storeId: data.storeId,
      ticketId: data.ticketId,
      latestMessage: data.latestMessage,
      influencerViewedTime: Math.round(data.influencerViewedTime || 0),
      storeViewedTime: Math.round(data.storeViewedTime || 0),
      influencerSentTime: Math.round(data.influencerSentTime || 0),
      storeSentTime: Math.round(data.storeSentTime || 0),
      adminSentTime: Math.round(data.adminSentTime || 0),
      createTime: Math.round(data.createTime || 0),
      updateTime: Math.round(data.updateTime || 0),
    };
  },
};
